<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-08-03 16:54:50
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-05 11:55:52
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/shopLibrary/list/tableCells/sampleCell.vue
 *
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved.
-->
<template>
	<div>
		<div v-if="row.task_status == 0">导入中…</div>
		<div v-else>
			<span
				>成功<span class="ml-4 yx-color-success">{{ row.success_count }}</span></span
			>
			<span class="ml-24" v-if="row.task_status != 1"
				>失败<span class="ml-4 yx-color-danger">{{ row.fail_count }}</span></span
			>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
};
</script>
<style lang="less" scoped>
</style>
